import { siteCurrencyAtom } from "@/config.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { listToObjectPrices } from "@/modules/pricing/resourcePricing.ts";
import { queryThen } from "@/utils/query/mergeQueries.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { PricingList } from "@warrenio/api-spec/spec.oats.gen";
import { atom } from "jotai/vanilla";

export const queryKey: QueryKey = ["pricing_list"];

export type Response = PricingList;

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> => {
            return getResponseData(await client.GET("/pricing/list/current", { signal }));
        },
    });
}

export const rawPricesAtom = atomFromStandardQueryOptions(getQuery);

export const pricesAtom = atom((get) =>
    queryThen(get(rawPricesAtom), (list) => listToObjectPrices(list, get(siteCurrencyAtom))),
);
